import { FunctionComponent, ReactNode } from "react";
import { Link } from "react-router-dom";

interface TileCardProps {
    icon: ReactNode;
    iconVariant?: "navy" | "orange" | "blue";
    title: string;
    subtitle: string;
    cta: string;
    to: string;
}

export const TileCard: FunctionComponent<TileCardProps> = ({
    icon,
    iconVariant = "navy",
    title,
    subtitle,
    cta,
    to,
}) => {
    return (
        <Link to={to} className="home-tile" aria-label={title}>
            <div className={`home-tile-icon ${iconVariant}`} aria-hidden="true">
                {icon}
            </div>
            <span className="home-tile-title">{title}</span>
            <span className="home-tile-subtitle">{subtitle}</span>
            <span className="home-tile-cta">{cta}</span>
        </Link>
    );
};
